import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { CUSTOM_ID } from '@nw/shared/config';
import { getAPIErrorMessage, getURLSearchParam } from '@nw/shared/utils';

import {
  CreateIbFormSubmissionRequestType,
  CreateIbFormSubmissionResponseType
} from '../../../services/FormsServices/APIService/types';

import { useFormsService } from '../useFormsService';

interface UseCreateIbFormSubmissionResponseInterface {
  createIbFormSubmissionAPI: UseMutateAsyncFunction<
    CreateIbFormSubmissionResponseType,
    unknown,
    CreateIbFormSubmissionRequestType,
    unknown
  >;
  error: string;
  status: MutationStatus;
}

const useCreateIbFormSubmission =
  (): UseCreateIbFormSubmissionResponseInterface => {
    const { formsServiceAPI } = useFormsService();

    const createIbFormSubmission = (
      request: CreateIbFormSubmissionRequestType
    ) => {
      const customId = getURLSearchParam().get(CUSTOM_ID);

      if (customId) {
        request.form_submission_data = JSON.stringify({
          ...JSON.parse(request.form_submission_data),
          custom_id: customId
        });
      }

      return formsServiceAPI.createIbFormSubmission(request);
    };

    const { mutateAsync, error, status } = useMutation(createIbFormSubmission, {
      mutationKey: ['createIbFormSubmission']
    });

    return {
      createIbFormSubmissionAPI: mutateAsync,
      error: error ? getAPIErrorMessage(error) : '',
      status
    };
  };

export { useCreateIbFormSubmission };
